import React from 'react';
import { useTranslation } from 'react-i18next';
import './index.scss';

export const PUBLIC_AUTH_ACTION_HREF = '/login';

export default function PublicAuthAction() {
  const { t } = useTranslation();

  return (
    <a
      className="public-auth-action"
      href={PUBLIC_AUTH_ACTION_HREF}
    >
      {t('auth.publicCta.join', { defaultValue: 'JOIN' })}
    </a>
  );
}
